<template>
	<div>
		<div>
			<TabMenu class="removeBorderWidth" :model="items" />
		</div>
		<div class="p-mt-2">
			<router-view />
		</div>
	</div>
</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';
import {useI18n} from "vue-i18n";
import TabMenu from "@/components/DexTabMenu.vue";
import {MenuItem} from "@/shims-prime-vue";

export default defineComponent({
	name: 'XmlMapperView',
	components: {
		TabMenu,
	},
	props: {},
	setup() {
		const {t} = useI18n();

		/** List of all Tab-Items */
		const items = computed(() => {
			const itemsList: MenuItem[] = [
				{label: t('Squeeze.XmlMapper.HeadData'), to: { name: 'XmlHeadDataView'}},
				{label: t('Squeeze.XmlMapper.PositionData'), to: { name: 'XmlPositionDataView'}},
				{label: t('Squeeze.XmlMapper.Testing'), to: { name: 'XmlMapperTestView'}},
			]

			return itemsList;
		});

		return {
			t,
			items,
		};
	},
});

</script>

<style lang="scss" scoped>

.removeBorderWidth  {
	border-bottom-width: 0;
}

</style>
